import React from "react";
import { FaSpinner } from "react-icons/fa"; // Import the loading spinner icon

function FullPageLoader() {
  return (
    <div className="full-page-loader">
      <FaSpinner className="spinner-icon" />{" "}
      {/* Use the loading spinner icon */}
      <p>Loading...</p>
    </div>
  );
}

export default FullPageLoader;
